<template>
  <div class="regras">
    <div class="title">REGRAS E CONDUTA NETSUPPORT</div>
    <div ref="regraContent" class="content">
      <h4 class="text-left negrito cor-verde-medio">1. Manifesto</h4>
      <br />
      <p>
        Sabemos que um problema de TI significa muito mais que um computador
        parado, são horas de trabalho desperdiçadas, dinheiro perdido, projetos
        atrasados e incontáveis inconvenientes.
      </p>
      <p>
        Sonhamos com a maior comunidade de TI do mundo para atender a qualquer
        um que precise de nós, a qualquer hora e em qualquer lugar.
      </p>
      <p>
        Apaixonados por tecnologia e como ela pode melhorar a vida das pessoas,
        reunimos
        <b>Supporters</b>, prontos para solucionar todo tipo de problema.
      </p>
      <p>
        Acreditamos que isso só é possível em uma empresa onde pessoas de todos
        os tipos, gostos, sexos e opções possam trabalhar dando seu melhor! Que
        mulheres entendem sim de informática, que um deficiente físico pode
        saber muito de TI e, que não há idade para quem é competente e quer
        produzir.
      </p>
      <h5 class="text-left negrito cor-laranja-escura">
        JUNTOS VAMOS ENSINAR, APRENDER, SE RELACIONAR E GANHAR DINHEIRO.
      </h5>
      <h5 class="text-left negrito cor-laranja-escura">
        VAMOS JUNTOS CRESCER E TORNAR NOSSO SONHO REALIDADE!
      </h5>
      <br />
      <br />

      <h4 class="text-left negrito cor-verde-medio">2. Introdução</h4>
      <br />
      <p>
        Este documento foi formulado para orientar os Supporters da nossa
        plataforma sobre o processo de atendimento de Jobs (chamados técnicos)
        dos clientes da NetSupport, bem como sobre os comprovantes necessários
        para os recebimentos dos valores.
      </p>
      <p>
        A NetSupport tem foco em oferecer atendimentos de suporte técnico de TI
        para empresas.
      </p>
      <p>
        Atualmente está presente em diversos seguimentos, como: escritórios,
        varejo, indústrias e empresas de TI (que utilizam nossos serviços tanto
        internamente, como em seus clientes). Mas todos eles nos procuram com um
        objetivo em comum: Solucionar problemas de TI.
      </p>
      <p>
        Os atendimentos de seus clientes são solucionados por profissionais de
        TI freelancers cadastrados em sua comunidade. Esses técnicos são
        denominados como Supporters.
      </p>
      <p>
        Cada cliente possui suas particularidades e processos, que devem ser
        respeitados, então, este documento te ensinará como conseguir as
        informações necessárias para segui-los de maneira adequada.
      </p>
      <h5 class="text-left negrito cor-laranja-escura">
        Obs. importante: É fundamental que todos os Supporters leiam e entendam
        claramente todas as regras, para que não tenham problemas durante a
        execução dos Jobs (chamados técnicos) e atrasos em seus recebimentos.
      </h5>
      <br />
      <br />

      <h4 class="text-left negrito cor-verde-medio">
        3. Conceitos Importantes
      </h4>
      <br />
      <p>
        <span class="cor-verde-medio">Portal da NetSupport:</span>
        Plataforma fornecida pela NetSupport para gerenciar seus Jobs, dados
        bancários, sua experiência técnica, disponibilidade de atendimento,
        quais cidades você atende, etc.
      </p>
      <p>
        Você acessa pela URL
        <a href="https://nssupport.netsupport.com.br" target="_blank">https://nssupport.netsupport.com.br</a>, ou
        através
        do aplicativo da NetSupport no Google Play.
      </p>
      <p>
        É fundamental que baixe nosso aplicativo e que todos os seus dados
        estejam preenchidos e atualizados, pois utilizamos eles para entender
        melhor suas competências e disponibilidades para atendimento. Também
        precisamos destas informações para melhorarmos nossos algoritmos e
        processos.
      </p>
      <p>
        NS Community:Ferramenta oficial de comunicação da NetSupport, Lá é onde
        você poderá se relacionar com os demais Supporters cadastrados, ensinar
        e aprender.
      </p>
      <p>
        Telegram: Onde postamos os todos os Jobs disponíveis para atendimento.
      </p>
      <p>
        <span class="cor-verde-medio">Gestor de Demandas:</span>
        Membro do time da NetSupport que atua como facilitador entre o cliente e
        o Supporter nos atendimentos de campo e remotos.
      </p>
      <h5 class="text-left negrito cor-laranja-escura">
        ATENÇÃO, SOMENTE OS GESTORES DE DEMANDA ESTÃO AUTORIZADOS A PASSAR JOBS
        QUE, OBRIGATÓRIAMENTE, JÁ FORAM CADASTRADOS NO PORTAL DA NETSUPPORT.
        CASO SEJA ABORDADO POR ALGUM OUTRO MEMBRO DA COMUNIDADE, OU COM JOBS QUE
        NÃO ESTEJAM DISPONÍVEIS NO PORTAL, , NÃO ACEITE E NOS INFORME O QUANTO
        ANTES.
      </h5>
      <p>
        O time Gestores de Demanda sempre utiliza a logo da NetSupport no
        Whatsapp. Portanto, fique atento! Caso tenha qualquer dúvida, nos
        procure nos canais de atendimento ao Supporter.
      </p>
      <p>
        <span class="cor-verde-medio">RAT - Relatório de Atendimento Técnico:</span>
        Documento utilizado para comprovação do atendimento realizado no
        cliente.
      </p>
      <p>
        <span class="cor-verde-medio">NS Academy:</span>
        Área de aprendizado da NetSupport. É onde publicamos todos os
        treinamentos, manuais e certificações.
      </p>
      <br />
      <br />

      <h4 class="text-left negrito cor-verde-medio">4. Atendimento aos Jobs</h4>
      <br />
      <p>
        Para que um Supporter possa atender Jobs da NetSupport é necessário que
        ele tenha cumprido as seguintes etapas:
      </p>
      <ol type="a">
        <li>Cadastrar-se no Portal da NetSupport;</li>
        <li>Aceitar os Termos de Uso;</li>
        <li>
          Ler e ser aprovado na prova sobre o documento de Regras e Conduta;
        </li>
        <li>Baixar nosso aplicativo no Google Play;</li>
        <li>Enviar a documentação necessária;</li>
        <li>Informar suas competências e experiências;</li>
        <li>Realizar e ser aprovado nos treinamentos obrigatórios</li>
      </ol>
      <p>
        Agora, vamos entender um pouco mais sobre as etapas do processo de
        atendimento e o que é preciso fazer para garantir o sucesso em cada uma
        delas.
      </p>
      <br />
      <h5 class="text-left cor-verde-medio">4.1. Oferta dos Jobs</h5>
      <p>
        Todos os Jobs serão publicados no Portal da NetSupport e posteriormente
        divulgados no aplicativo e no Telegram, ferramenta oficial de
        comunicação da NetSupport, e enviado via e-mail, seguindo as seguintes
        premissas:
      </p>
      <p>
        <span class="cor-verde-medio">Chamados de suporte de campo:</span>
        Será postado no canal #job, que é aberto para toda a comunidade. Também
        será divulgado de acordo com a sua cidade através do aplicativo,
        Telegram e e-mail.
        <br /><br />
        OBS: O Supporter ainda poderá ser selecionado a realizar um Job em
        cidades com um raio de até 150km
      </p>
      <p>
        <span class="cor-verde-medio">Chamados com solução remota:</span>
        Será postado no canal #Job que é aberto para todos da comunidade. Será
        divulgado para toda a comunidade através do aplicativo, Telegram e
        e-mail.
      </p>
      <p>
        Obs.: Em alguns casos, como uma alternativa emergencial, utilizamos o
        WhatsApp apenas para informar que existem Jobs disponíveis no Portal.
      </p>

      <br />
      <h5 class="text-left cor-verde-medio">4.2. Aceite dos Jobs</h5>
      <p>
        Os Supporters que se candidatarem, demonstrando interesse em realizar o
        atendimento, serão avaliados dentro dos critérios abaixo para seleção.
        Só conseguem se candidatar a um JOB os Supporters que estiverem em dia
        com a documentação no portal e e tenham feito os Treinamentos que sejam
        pré-requisitos.
      </p>
      <p>
        Ao se candidatar a um job no Portal da NetSupport, este declara estar
        ciente e que aceita as regras que constam neste documento, bem como das
        orientações para realização do Job.
      </p>
      <h5 class="text-left negrito cor-laranja-escura">
        IMPORTANTE: Antes de se candidatar a um Job, é importante que o
        Supporter verifique se terá condições de atendê-lo, observando,
        atentamente, se o seu conhecimento técnico é compatível com o problema
        descrito no Job, se o tempo de deslocamento até o local do chamado está
        adequado com o prazo de início do atendimento e se possui todas as
        ferramentas necessárias para o concluir o serviço em questão.
      </h5>

      <br />
      <h5 class="text-left cor-verde-medio">
        4.3. Critérios para Aceite dos Jobs
      </h5>
      <p>
        Além dos passos obrigatórios informados no item 4, é necessário que o
        Supporter atenda a todos os critérios abaixo:
      </p>
      <ol type="a">
        <li>Estar disponível para o atendimento;</li>
        <li>
          Estar de acordo com os critérios para atendimento no ambiente do
          cliente;
        </li>
        <li>
          Ter o conhecimento técnico necessário para o atendimento ao Job;
        </li>
        <li>Histórico do Supporter na Plataforma;</li>
        <li>Score de Atendimento</li>
      </ol>

      <br />
      <h5 class="text-left cor-verde-medio">4.4. Fases do Atendimento</h5>
      <p>
        Todos os atendimentos da NetSupport passam obrigatoriamente por algumas
        fases que são divididas da seguinte maneira:
      </p>
      <ol type="a">
        <li>Orientação: Supporter recebe as informações sobre o job;</li>
        <li>
          Deslocamento: Supporter informa que está a caminho do local do job;
        </li>
        <li>
          Check-in: Supporter sinaliza que chegou e está pronto para iniciar o
          processo;
        </li>
        <li>Check-out</li>
        <li>
          Finalização do Job: Supporter informa que concluiu o atendimento;
        </li>
        <li>
          Validação: Gestor de demandas valida a conclusão do atendimento;
        </li>
        <li>
          Encerramento: Após 3 dias, caso não volte o problema o job é
          encerrado.
        </li>
      </ol>
      <p>
        Se o Supporter não siga os passos do processo que cabem a ele realizar,
        no prazo determinado, este ato incidirá diretamente em seu Histórica de
        Atendimento e no Score, o uso do aplicativo automatiza alguns destes
        processos.
      </p>

      <br />
      <h5 class="text-left cor-verde-medio">4.5. Atendimento dos Jobs</h5>
      <p>
        O Supporter selecionado para o Job será contatado pelo gestor de demanda
        e irá até o cliente, no caso de chamados de campo. Quando for um chamado
        remoto, ele acessará a máquina do cliente, através de uma ferramenta de
        acesso remoto, e aplicará a solução mais adequada para o problema do
        cliente.
      </p>
      <p class="text-left cor-verde-medio">4.5.1 Jobs Remotos</p>
      <p>
        O Gestor de Demandas responsável pelo Job efetua conferência telefônica
        entre Supporter e cliente para a realização do Job. Caso haja
        necessidade de realizar acesso remoto no computador do cliente, o
        Supporter deverá disponibilizar a ferramenta pela qual o procedimento
        será realizado.
      </p>
      <p class="text-left cor-verde-medio">4.5.2 Jobs Presenciais</p>
      <p>
        O Supporter precisa informar cada fase do atendimento através do Portal
        da NetSupport, desde que está devidamente orientado, do início do
        deslocamento, check-in no cliente e conclusão do atendimento. Com o uso
        do aplicativo o deslocamento e check-in ficam de forma automática, o
        Supporter precisa apenas abrir o aplicativo em seu celular antes de
        iniciar o deslocamento
      </p>
      <p>
        Em alguns casos podem ser solicitados outros processos adicionais, que
        estarão sempre disponibilizados na descrição do Job.
      </p>
      <p>
        O seu contato para eventuais problemas ou discrepâncias no atendimento
        será sempre o Gestor de Demandas. Portanto, caso tenha qualquer problema
        ou dúvida informe imediatamente a ele e solicite apoio.
      </p>
      <p>
        Fique atento às instruções contidas no job, lá constarão as informações
        e procedimentos, seguindo o padrão de cada cliente.
      </p>
      <h5 class="text-left negrito cor-laranja-escura">Dicas Importantes:</h5>
      <p>
        Durante o atendimento dos Jobs, ao realizar interações com os clientes
        (seja por chat, áudio nos atendimentos remotos ou presencialmente em
        campo) é importante fazer uso adequado de linguagem, evitando
        tratamentos excessivamente informais e uso de gírias. Para os jobs
        presenciais, evitar uso de roupas inadequadas (bermudas, camisetas
        cavadas, saias excessivamente curtas, decotes exagerados, etc).
      </p>
      <h5 class="text-left negrito cor-laranja-escura">
        Lembrem-se: Você está atendendo um cliente, que dede ser tratado como
        tal. Seja educado, atencioso e mantenha sempre o respeito. Esse é o
        comportamento esperado de um Supporter.
      </h5>
      <p>
        Antes de iniciar o atendimento é extremamente importante que você leia
        com atenção a descrição do Job no Portal da NetSupport para que consiga
        atender as necessidades do cliente com assertividade.
      </p>
      <p>
        Durante o atendimento, caso tenha necessidade de inserir uma nota de
        acompanhamento no Job, ela deve ser feita da seguinte forma:
      </p>
      <ol type="a">
        <li>Entre no Job que precisa inserir uma anotação;</li>
        <li>
          Procure abaixo dos botões principais, o botão auxiliar ‘Inserir Anotação'
          (sempre estará habilitado);
        </li>
        <li>
          Descreva as informações de forma clara, lembre-se que o cliente também
          terá acesso e precisa entender;
        </li>
        <li>
          Para terminar de inserir uma nota, siga as instruções disponíveis no
          ícone de ponto de interrogação (?) disponível ao lado do campo.
        </li>
      </ol>

      <br />
      <h5 class="text-left cor-verde-medio">4.6. Aplicativo</h5>
      <p>
        É necessário baixar e instalar o aplicativo da NS. Para todo atendimento
        você deve abrir o app antes do início do deslocamento para o
        acompanhamento do GD e isso fará com que seu check-in seja feito de
        forma automática. <br />OBS: Atualmente disponível apenas Android.
      </p>
      <br />
      <h5 class="text-left cor-verde-medio">
        4.7. Finalização dos Jobs no Portal da NetSupport
      </h5>
      <p>
        Após resolver o problema do cliente, é necessário realizar o fechamento
        do no Portal da NetSupport, antes de sair do cliente. Isso evita que,
        caso haja algum erro no processo de validação do chamado, você tenha que
        voltar até o cliente para correção.
      </p>
      <p>Segue abaixo, em sequência, os passos para executar o fechamento:</p>
      <ol type="a">
        <li>
          Preencher e subir o RAT do atendimento assinado pelo Supporter e
          responsável no cliente, legível e sem rasuras. Importante ressaltar
          que, quando houver número de chamado do cliente especificado na
          descrição do job, o número a ser preenchido no RAT é o NÚMERO DO
          CLIENTE e não o número do Job da Portal NetSupport. Nos casos onde o
          cliente não tem número de chamado especificado, o número a ser
          preenchido é o do job da NetSupport. Em alguns clientes podem ser
          exigidos outros documentos.
          <h5 class="text-left negrito cor-laranja-escura">
            Os Jobs sem RAT, modelo incorreto, preenchimento incompleto ou
            documentos ilegíveis (digitalização de baixa qualidade, amassado,
            rasurado ou letra mal escrita) NÃO SERÃO VALIDADOS, e não serão
            considerados fechados em definitivo. Isso terá impacto direto no
            prazo de pagamento. É necessário o preenchimento do RAT e upload
            dele na plataforma antes de sair do cliente.
          </h5>
        </li>
        <li>Clicar em “Encerrar”;</li>
        <li>
          Inserir o tempo de duração do atendimento no cliente;
          <h5 class="text-left negrito cor-laranja-escura">
            O tempo de atendimento informado no Portal da NetSupport deverá
            obrigatoriamente ser o mesmo do registrado no RAT. Caso haja
            divergência entre estas informações a NetSupport considerará como
            válido a duração registrada no RAT e invalidará o chamado, sendo
            necessária a correção da informação no portal. Caso o tempo
            estipulado para o atendimento não for suficiente para a finalização
            dos procedimentos, o Supporter deverá informar ao Gestor de
            Demandas, pelo Slack, sobre a necessidade de ampliar o tempo para
            conclusão com no mínimo 20 minutos de antecedência e justificar
            claramente os motivos para obter autorização. O atendimento não deve
            prosseguir sem autorização da NetSupport após transcorridas o tempo
            pré-determinado. Caso o Supporter esqueça por algum motivo de
            informar a NetSupport, o período adicional não será remunerado. (A
            NetSupport remunera atuação no Job, apenas o período de atendimento
            dentro do cliente)
          </h5>
        </li>
        <li>
          Inserir um resumo do procedimento realizado, para o histórico do
          cliente.
        </li>
      </ol>
      <p>
        Em alguns casos, podem ser exigidos alguns processos extra, como por
        exemplo, ligar no Service Desk do cliente para validação da solução
        aplicada. Fique sempre atendo nas orientações do atendimento disponíveis
        no Job.
      </p>
      <h5 class="text-left negrito cor-laranja-escura">
        O Supporter deverá informar tudo o que foi feito para resolver o
        problema do cliente, esta descrição deve ser a síntese com o que foi
        descrito no RAT, mantendo a coerência em ambos os registros. Esta
        informação é fundamental para que o cliente entenda a solução aplicada e
        concorde com ela.
      </h5>

      <br />
      <h5 class="text-left cor-verde-medio">
        4.8. Validação e Fechamento do Job
      </h5>
      <p>
        Os jobs deverão ser fechados imediatamente após o atendimento, ainda
        antes de sair do cliente. Após o fechamento, nossa equipe realizará a
        conferência e validação do RAT, liberando o Supporter e autorizando sua
        saída.
      </p>

      <br />
      <h5 class="text-left cor-verde-medio">4.9. Abandono e Desistência</h5>
      <p>
        <span class="cor-verde-medio">Conceitos</span>
      </p>
      <p>
        <span class="cor-verde-medio">Abandono de Job:</span>
        Consideramos abandono de Job quando um Supporter chega no cliente inicia
        o atendimento e por algum motivo sai do cliente sem resolver o problema
        em questão.
      </p>
      <p>
        Ou ainda quando o Supporter se compromete em atender um Job e não
        comparece ao atendimento, sem informar ao Gestor de Demandas da
        NetSupport com antecedência mínima de 2 horas.
      </p>
      <p>
        <span class="cor-verde-medio">Desistência de Job:</span>
        Consideramos desistência de Job quando um Supporter aceita o Job e antes
        de ir ao atendimento informa ao Gestor da Demanda que não realizará mais
        o atendimento.
      </p>
      <p>
        Ambas as situações sofrem as mesmas consequências, e incidem diretamente
        no histórico do Supporter na NetSupport.
      </p>
      <p>
        <span class="cor-verde-medio">Consequências dos Abandonos e Desistências</span>
      </p>
      <p>
        Independentemente de ser abandono ou desistência, as consequências serão
        as mesmas e são elas:
      </p>
      <ol type="a">
        <li>
          Na primeira vez que o Supporter desistir ou abandonar um Job ele será
          notificado;
        </li>
        <li>
          Na segunda vez que o Supporter desistir ou abandonar um Job ele será
          impedido de atender Jobs pelos próximos 30 dias;
        </li>
        <li>
          Na terceira vez que o Supporter desistir ou abandonar um Job ele será
          impedido de atender Jobs pelo período de 1 ano;
        </li>
        <li>
          Toda desistência ou abandono terá impacto direto no histórico do
          Supporter, que será um dos critérios de avaliação para poder atuar em
          Jobs;
        </li>
      </ol>
      <p>O afastamento do Supporter das atividades será em caráter punitivo.</p>

      <br />
      <h5 class="text-left cor-verde-medio">
        4.10. Ferramentas Recomendadas para o bom Atendimento
      </h5>
      <p>
        A NetSupport recomenda que os Supporters tenham os seguintes
        equipamentos básicos para o atendimento de Jobs de campo. Estes não são
        obrigatórios para todos os atendimentos, porém quando o job necessitar,
        é de responsabilidade do Supporter ter estas ferramentas:
      </p>
      <ol type="a">
        <li>
          RAT (Relatório de atendimento técnico) impresso para ser preenchido
          após os atendimentos;
        </li>
        <li>Chave de fenda;</li>
        <li>Chave Philips;</li>
        <li>HD Externo ou Pendrive;</li>
        <li>Cabo console DB9 - Rj45 (Conversores para HDMI e USB);</li>
        <li>Notebook;</li>
        <li>Cabo de rede rj45;</li>
        <li>Teclado (quando tiver que conectar a um servidor);</li>
        <li>Mouse;</li>
        <li>Smartphone com acesso a internet;</li>
        <li>Escada;</li>
        <li>Furadeira.</li>
      </ol>
      <p>
        Eventualmente podem ser solicitadas outras ferramentas pelo cliente,
        quando ocorrer esta informação estará disponível na descrição do Job.
      </p>

      <br />
      <h5 class="text-left cor-verde-medio">4.11. Score</h5>
      <p>
        O Score de Atendimento foi criado com o intuito de avaliar a atuação do
        Supporter nos atendimentos realizados para os clientes NetSupport. O
        Histórico do Supporter avalia os seguintes fatores.
      </p>
      <ol type="a">
        <li>
          Resolução do Problema - Capacidade do Supporter de encontrar uma
          solução satisfatória para o problema reportado pelo cliente;
        </li>
        <li>
          Pontualidade do Supporter - No início do atendimento o Supporter
          deverá fazer o check-in do Job, dentro da Portal da NetSupport;
        </li>
        <li>
          Feedback do Cliente - Satisfação do cliente em relação ao atendimento
          geral do Supporter (postura, apresentação, etc);
        </li>
        <li>
          Abandono ou Desistência - Sua ocorrência atua como deflator no
          histórico do supporter.
        </li>
      </ol>

      <br />
      <h5 class="text-left cor-verde-medio">
        4.12. Outras Informações Importantes
      </h5>
      <ol type="a">
        <li>
          O atendimento de campo sempre começa a contar a partir da chegada no
          cliente e não a partir do acionamento;
        </li>
        <li>
          É obrigação do Supporter deter todos os meios que possibilitem seu
          acesso ao cliente e a solução de seus problemas, incluindo, mas não se
          limitando a veículo (próprio, de terceiros ou transporte público),
          todas as ferramentas e equipamentos para a perfeita execução dos
          serviços, sendo de sua única e exclusiva responsabilidade a manutenção
          desses itens.
        </li>
        <li>
          A NetSupport não reembolsa alimentação (almoço, lanche ou jantar) sem
          autorização prévia do cliente final ou do Gestor de Demandas. Sendo
          assim, essa é uma responsabilidade do Supporter;
        </li>
        <li>
          A NetSupport não reembolsa pedágios ou estacionamentos. Exceções para
          atendimentos em aeroportos ou locais de risco, por exemplo. Contudo,
          os valores devem ser negociados antes de se iniciar o deslocamento
          para o Job;
        </li>
        <li>
          Alguns de nossos clientes possuem orientações e processos específicos,
          que devem ser respeitados e seguidos. Esta informação estará, sempre,
          disponível na descrição do job no Portal da NetSupport. Fique atento!
        </li>
        <li>
          Os chamados serão auditados pela NetSupport, caso tenha alguma
          pendência e a correção não for feita no ciclo do faturamento corrente,
          o Supporter terá o prazo até 30 dias para proceder com o ajuste
          necessário, caso este prazo não seja respeitado, o pagamento deste Job
          não será realizado.
        </li>
      </ol>
      <br />
      <br />

      <h4 id="pagamento" class="text-left negrito cor-verde-medio">5. Pagamentos</h4>
      <br />
      <p>
        A NetSupport conta com diversos tipos de Jobs, com valores de
        remuneração diferenciada. Esta informação estará sempre disponibilizada
        na descrição do Job no portal. Para consultar, basta clicar na mensagem
        de divulgação no telegram, e-mail ou app NetSupport.
      </p>
      <p>
        <span class="cor-verde-medio">Jobs Padrão (2 horas, meia diária, diária e alocações inferiores a 30
          dias)</span>
      </p>
      <p>
        Os pagamentos serão realizados sempre no quarto ciclo após o fechamento
        do job e validação do RAT.
      </p>
      <p>
        Os pagamentos são realizados em três ciclos diferentes ao longo do mês,
        sendo eles nos dias 05, 15 e 25 (exceto quando estas datas caírem em
        finais de semana ou feriados), conforme cronograma abaixo:
      </p>
      <p>
        <span class="negrito">Jobs fechados entre os dias 01 e 10:</span>
        Pagamento realizado no dia 15 do mês seguinte;
      </p>
      <p>
        <span class="negrito">Jobs fechados entre os dias 11 e 20:</span>
        Pagamento realizado no dia 25 do mês seguinte;
      </p>
      <p>
        <span class="negrito">Jobs fechados entre os dias 21 e último dia do mês:</span>
        Pagamento será realizado no dia 5 do segundo mês subsequente;
      </p>
      <p>Para facilitar o seu entendimento, confira as seguintes hipóteses:</p>
      <p>Job fechado em 03/02/2019 será pago no dia 15/03/2019;</p>
      <p>Job fechado em 13/02/2019 será pago no dia 25/03/2019;</p>
      <p>Job fechado em 23/02/2019 será pago no dia 05/04/2019.</p>
      <br />
      <p>
        <span class="cor-verde-medio">Jobs de Alocação (períodos superiores a 1 semana, com apenas 1
          Job)</span>
      </p>
      <p>
        Os pagamentos serão realizados no segundo ciclo após o fechamento do job
        e validação do RAT.
      </p>
      <p>
        Os ciclos de pagamentos dos jobs serão realizados nos dias 05, 15 e 25
        de todos os meses (exceto quando estas datas caírem em finais de semana
        ou feriados).
      </p>
      <p>Para facilitar o seu entendimento, confira as seguintes hipóteses:</p>
      <p>Alocações finalizadas dia 26/01/2019 será pago no dia 15/02/2019;</p>
      <p>Alocações finalizadas dia 05/03/2019 será pago no dia 25/03/2019;</p>
      <p>Alocações finalizadas dia 17/06/2019 será pago no dia 05/07/2019;</p>
      <h5 class="text-left negrito cor-laranja-escura">
        Os pagamentos são realizados por Transferência Bancária (TED) via bancos
        Santander e Banco do Brasil. Caso o Supporter tenha interesse em receber
        por outro banco, será descontada a Taxa de Transferência no valor
        vigente na tabela do banco de origem. Dependendo do banco, o TED pode
        cair no dia útil seguinte à transação.
      </h5>
      <p>
        * O pagamento será feito apenas mediante apresentação da Nota Fiscal do serviço prestado. A nota deverá ser
        anexada no portal, até no máximo 3 dias corridos antes da data de pagamento.
      </p>
      <p>
        * Toda NF deverá ser emitida no mês de competência do pagamento e a não entrega no prazo poderá implicar em
        atraso no pagamento dos valores.
      </p>
      <p>
        Não haverá, em hipótese alguma adiantamento de valores pela NETSUPPORT
        ao SUPPORTER.
      </p>
      <p>
        Reiteramos que para um job ser considerado fechado, é preciso que ele
        seja finalizado no portal e que seu respectivo RAT esteja validado.
      </p>
      <p>
        É muito importante que você siga TODAS as instruções para o fechamento
        de maneira consistente. Assim, você evita que seu RAT não seja validado,
        gerando atrasos para o seu próprio pagamento.
      </p>
      <h5 class="text-left negrito cor-laranja-escura">
        Observação: alocação mensal rescindida antes da data final tem seu ciclo
        de pagamento dois ciclos após o fechamento e validação no portal.
      </h5>
      <br />
      <br />

      <h4 class="text-left negrito cor-verde-medio">6. Conduta</h4>
      <br />
      <p>
        A NetSupport respeita o livre direito de manifestação dos membros de sua
        comunidade, mas com objetivo de manter o foco no propósito da comunidade
        e nos valores e princípios que acredita, recomenda-se que as discussões
        sejam relacionadas ao contexto de Tecnologia da Informação, ficando
        vedado (passível de advertências ou até mesmo exclusão da comunidade) os
        seguintes comportamentos:
      </p>
      <ol type="a">
        <li>Uso de palavras de baixo calão;</li>
        <li>
          Conteúdos que incitem o preconceito e a intolerância contra raça,
          gênero, orientação sexual, deficiência física ou intelectual.
        </li>
        <li>Compartilhamento de mensagens de correntes;</li>
        <li>Divulgação de produtos ou serviços próprios ou de terceiros;</li>
        <li>Reclamar da NetSupport para o cliente.</li>
      </ol>
      <p>
        Evite comentários sobre modelos operacionais dos clientes, opiniões
        pessoais sobre suas plataformas. Lembre-se, você não está falando com um
        amigo e sim um cliente, foque em resolver o problema.
      </p>
      <p>
        Equipamentos dos clientes não devem ser retirados do local sem
        comunicação, justificativa e aprovação da NetSupport, a não ser que o
        propósito do atendimento seja de realizar transporte dos dispositivos.
      </p>
      <p>
        Em atendimentos presenciais a clientes residenciais, a visita deverá ser
        suspensa caso no local tenha menores de idade sem a presença de um
        adulto responsável pelo menor. Neste caso a NetSupport deverá ser
        informada imediatamente para reagendar o atendimento.
      </p>
      <br />
      <br />

      <h4 class="text-left negrito cor-verde-medio">
        7. Comunicação e Relacionamento
      </h4>
      <br />
      <p>
        A NetSupport conta com 3 canais de comunicação oficiais, veja abaixo e
        entenda o funcionamento deles:
      </p>
      <p>
        <span class="cor-verde-medio">NS Community</span>
      </p>
      <p>
        O NS Community é a nossa principal ferramenta de comunicação, é lá que
        ocorre toda a interação dos Supporters da comunidade, publicação de
        comunicados oficiais. e também a distribuição de Jobs. Veja a função dos
        canais:
      </p>
      <p>
        <span class="negrito">#Bate-papo:</span>
        Canal aberto para interação entre os Supporters e Funcionários da
        NetSupport.
      </p>
      <p>
        <span class="negrito">#Comunicado:</span>
        Canal destinado para publicação de comunicados oficiais da NetSupport
        para os Supporters.
      </p>
      <p>
        <span class="negrito">Financeiro:</span>
        Canal para dúvidas rápidas sobre processo de pagamentos. No caso de
        dúvidas mais complexas o Supporters será direcionado ao canal de e-mail,
        nsresolve@netsupport.com.br
      </p>
      <p>
        <span class="negrito">Plataforma:</span>
        Canal destinado para informações sobre o Portal da NetSupport, como
        dúvidas, atualizações e Bugs.
      </p>
      <p>
        <span class="negrito">Job:</span>
        Canal destinado para a divulgação dos Jobs dos clientes da NetSupport.
        Este canal não permite o envio de mensagens, apenas notificações
        automáticas.
      </p>
      <br />
      <p>
        <span class="cor-verde-medio">Chat</span>
      </p>
      <p>
        Através do chat, disponível na página
        <a href="https://www.netsupport.com.br/seja-um-supporter/"
          target="_blank">https://www.netsupport.com.br/seja-um-supporter/</a>, e em breve no Portal da NetSupport, você
        pode conversar com a nossa
        equipe para tirar dúvidas rápidas. No caso de dúvidas mais complexas o
        Supporter será direcionado ao canal de e-mail,
        <a href="mailto:nsresolve@netsupport.com.br">nsresolve@netsupport.com.br</a>
      </p>
      <p>
        O horário de funcionamento deste canal é de segunda a sexta-feira das
        9:00h às 19:00.
      </p>
      <br />
      <p>
        <span class="cor-verde-medio">Telegram, E-mail e Whatsapp</span>
      </p>
      <p>
        Atráves do Telegram e e-mail fazemos divulgação dos Jobs disponíveis
        para sua cidade. No e-mail e Whatsapp mandamos também as principais
        notícias da NetSupport e as campanhas de incentivo que estão em vigor.
      </p>
      <br />
      <p>
        <span class="cor-verde-medio">Atendimento ao Supporter</span>
      </p>
      <p>
        Sempre que Supporters enfrentarem problemas mais complexos, sejam
        financeiros ou operacionais, a equipe da NetSupport direcionará o
        Supporter a este canal. Isso porque ele gera um ticket de atendimento
        interno, onde conseguimos controlar tempo e eficiência de respostas.
      </p>
      <p>
        Para acionar este canal, basta enviar um e-mail para
        <a href="mailto:nsresolve@netsupport.com.br">nsresolve@netsupport.com.br</a>, através do e-mail cadastrado no
        Portal da NetSupport, contendo as
        informações ou dúvidas de maneira detalhada e de fácil entendimento.
      </p>
      <p>
        O prazo para retorno da nossa equipe é de 48h úteis, contados a partir
        do momento do recebimento do e-mail.
      </p>
      <br />
      <br />

      <h4 class="text-left negrito cor-verde-medio">8. Conclusão</h4>
      <br />
      <p>
        Importante ressaltar que o descumprimento das recomendações presentes
        neste documento terá impacto negativo no histórico do Supporter, tendo
        como consequência restrição na oferta de Jobs, inelegibilidade parcial,
        temporária ou até mesmo definitiva para realização de atendimentos
        futuros, conforme descrito no item Histórico do Supporter
      </p>
      <p>
        E lembre-se sempre, nós estamos aqui para proporcionar a melhor
        experiência na plataforma. Durante qualquer momento, seja em um
        atendimento ou por uma dúvida, nos procure pelos nossos canais de
        comunicação, para que possamos lhe oferecer o devido apoio.
      </p>
      <br />
      <br />
    </div>

    <div class="buttons text-center">
      <div id="warn" v-if="!modal.hideButton">Leia até o final para liberar o botão de <b>Aceite</b>.</div>
      <div v-if="modal.hideButton" class="info text-center">Aceito em<br />{{ modal.hideButton | date }}</div>
      <Button v-else id="btn_regra" :loader="load" layout="green-m" @click="accept_rules" :disabled="true">ACEITAR
        REGRAS E CONDIÇÕES</Button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
export default {
  name: "Regras",
  props: { modal: Object },
  components: { Button },
  data() {
    return { load: false };
  },
  mounted() {
    let myDiv = this.$refs.regraContent
    myDiv.onscroll = function () {
      if (myDiv.offsetHeight + myDiv.scrollTop > (myDiv.scrollHeight - 1200)) {
        document.getElementById('btn_regra').disabled = false
        document.getElementById('warn').innerHTML = ""
      }
    }

    const pag = this.$route.query.pagamento;
    if (pag) {
      setTimeout(() => {
        this.$refs.regraContent.scrollTo({
          top: document.getElementById('pagamento').offsetTop - 250,
          behavior: 'smooth'
        });
      }, 1000);
    }
  },
  methods: {
    ...mapActions("user", ["ACCEPT_RULES"]),
    accept_rules() {
      this.load = true;
      this.ACCEPT_RULES().then((r) => {
        if (r.status === 200 || r.status === 201) {
          if (this.modal.callback) this.modal.callback();
          this.modal.show = false;
          this.load = false;
        }
      }).catch(() => (this.load = false));
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.regras {
  color: $gray-6;
  padding: 10px 30px;
  max-width: 900px;
  border-radius: 12px;
  background: $white;

  .title {
    font-size: 22px;
    font-weight: 600;
    padding: 30px 0px;
    color: $purple;
  }

  .content {
    color: $gray-1;
    text-align: justify;
    font-size: 12px;
    line-height: 27px;
    max-height: 500px;
    overflow: auto;
  }

  .buttons {
    padding: 20px;

    .info {
      color: $purple;
    }

    #warn {
      color: $red-1;
      font-size: 14px;
      margin-bottom: 12px;
    }
  }

  .status {
    margin-left: -21%;
  }
}
</style>